import { Component, inject, input, viewChild } from '@angular/core';
import SwiperCore, { Navigation } from 'swiper';
import { SwiperComponent, SwiperModule } from 'swiper/angular';
import { MainHeaderComponent } from '@/main/main-header/main-header.component';
import { MobileWrapperComponent } from '@/common/mobile-wrapper/mobile-wrapper.component';
import { OfferBoxMobileComponent } from '@/main/offer-boxes/offer-box-mobile/offer-box-mobile.component';
import { OfferBoxComponent } from '@/main/offer-boxes/offer-box/offer-box.component';
import { CommonModule } from '@angular/common';
import { MainService } from '@/main/services/main.service';
import { STANDARD_SWIPER_CONFIG } from '@/main/sections/swiper-sections.config';
import { MainLoaderComponent } from '@/main/main-loader/main-loader';

SwiperCore?.use([Navigation]);

@Component({
	selector: 'app-main-standard',
	templateUrl: './main-standard.component.html',
	imports: [
		MainHeaderComponent,
		SwiperModule,
		MobileWrapperComponent,
		OfferBoxMobileComponent,
		OfferBoxComponent,
		CommonModule,
		MainLoaderComponent,
	],
	standalone: true,
})
export class MainStandardComponent {
	readonly query = input.required<string>();
	readonly title = input.required<string>();
	readonly titleSuffix = input.required<string>();

	readonly mainService = inject(MainService);

	readonly offerList$ = this.mainService.fetchOfferListFromQuery$(this.query);

	readonly swiperConfig = STANDARD_SWIPER_CONFIG;

	private readonly swiper = viewChild(SwiperComponent);

	swipePrev(): void {
		this.swiper().swiperRef.slidePrev();
	}

	swipeNext(): void {
		this.swiper().swiperRef.slideNext();
	}
}
